import { useI18n } from '@/hooks/web/useI18n'

const { t } = useI18n()

const loginRouter: AppRouteRecordRaw[] = [
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  }
]

export default loginRouter
